module.exports = __webpack_public_path__ + "img/gold.773afa66.png";